import React from 'react';
import './viral-css.css';
// import AuthNav from '../../auth/nav/Nav';

const Viral = () => (
    <div id="viral-div-1">
        {/*<AuthNav/>*/}
        <div className="viral-div-2a" id="viral-div-2a">
            {/*<h1 id="viral-h1">*/}
                {/*The top 25 @users on Twitter drive*/}
                {/*20% of the network's interactions*/}
            {/*</h1>*/}
        </div>
        <div className="viral-div-2b" id="viral-div-2b">
            <h3 className="viral-h3">
              <a href="https://army.girlposts.net">
                army.girlposts.net
              </a>

            </h3>
          <h3 className="viral-h3">
            <a href="https://e.viral.net/sodamntrue">
              not Engage
            </a>

          </h3>
          <h3 className="viral-h3">
            <a href="https://g.viral.net">
              global Twtr traffic
            </a>

          </h3>
        </div>
        {/*<div className="viral-div-2c" id="viral-div-2c">*/}
            {/*<p className="viral-p-1a">*/}
                {/*Viral deploys native video tweets at the nexus of social graphs, driving 2-10 million video views every day.*/}
            {/*</p>*/}
        {/*</div>*/}
        {/*<div className="viral-div-2b" id="viral-div-2d">*/}
            {/*<h3 className="viral-h3">*/}
                {/*Results*/}
            {/*</h3>*/}
        {/*</div>*/}
        {/*<div className="viral-div-2c" id="viral-div-2e">*/}
            {/*<p className="viral-p-1a">*/}
                {/*800 million video views,*/}
                {/*200 #1 Trends in the iOS App Store,*/}
                {/*9 million app downloads at an average install cost of $0.2.*/}
            {/*</p>*/}
        {/*</div>*/}
        {/*<div className="viral-div-2b">*/}
            {/*<h3 className="viral-h3">*/}
                {/*Network*/}
            {/*</h3>*/}
        {/*</div>*/}
        {/*<div className="viral-div-2c">*/}
            {/*<p className="viral-p-1a">*/}
                {/*Our extended network consists of 400 @users on Instagram and Twitter totalling 1 billion followers.*/}
            {/*</p>*/}
        {/*</div>*/}
    </div>
);

export default Viral;


// WEBPACK FOOTER //
// ./src/components/core/viral/Viral.js